import React from 'react';

export const DottedLineIcon: React.FC<{
  colorClass: string;
}> = ({ colorClass }) => {
  return (
    <div className="flex flex-row gap-1">
      <div className={`${colorClass} w-2 h-1 rounded-full`}></div>
      <div className={`${colorClass} w-2 h-1 rounded-full`}></div>
      <div className={`${colorClass} w-2 h-1 rounded-full`}></div>
    </div>
  );
};
